'use client';

import React from 'react';
import { Twitter, Linkedin } from 'lucide-react';
import Link from 'next/link';
import NextImage from 'next/image';

export const Footer = () => {
    return (
        <footer className="bg-white text-neutral-500 py-20 border-t border-neutral-100">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid md:grid-cols-12 gap-12 mb-20">
                    {/* Brand Column */}
                    <div className="md:col-span-3">
                        <div className="flex items-center gap-2 mb-6">
                            <NextImage src='/axist.png' width={32} height={32} className='h-8 w-8 rounded-lg shadow-sm' alt="Axist" unoptimized />
                            <span className="text-xl font-bold text-neutral-900 tracking-tight">Axist</span>
                        </div>
                        <p className="text-sm text-neutral-500 leading-relaxed font-medium">
                            Your AI Marketing Department. <br />
                            5 autonomous agents working 24/7.
                        </p>
                    </div>

                    {/* Links Columns */}
                    <div className="md:col-span-2">
                        <h4 className="text-sm font-bold text-neutral-900 mb-6 uppercase tracking-wider">Company</h4>
                        <ul className="space-y-4 text-sm font-medium">
                            <li><Link href="#" className="hover:text-orange-600 transition-colors">About</Link></li>
                            <li><Link href="/customers" className="hover:text-orange-600 transition-colors">Customers</Link></li>
                            <li><Link href="/blog" className="hover:text-orange-600 transition-colors">Blog</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-sm font-bold text-neutral-900 mb-6 uppercase tracking-wider">Agents</h4>
                        <ul className="space-y-4 text-sm font-medium">
                            <li><Link href="#agents" className="hover:text-orange-600 transition-colors">The Scout</Link></li>
                            <li><Link href="#agents" className="hover:text-orange-600 transition-colors">The Buyer</Link></li>
                            <li><Link href="#agents" className="hover:text-orange-600 transition-colors">The Editor</Link></li>
                            <li><Link href="#agents" className="hover:text-orange-600 transition-colors">The Builder</Link></li>
                            <li><Link href="#agents" className="hover:text-orange-600 transition-colors">The Receptionist</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="text-sm font-bold text-neutral-900 mb-6 uppercase tracking-wider">Support</h4>
                        <ul className="space-y-4 text-sm font-medium">
                            <li><a href="mailto:support@axist.app" className="hover:text-orange-600 transition-colors">Contact Us</a></li>
                            <li><Link href="/faq" className="hover:text-orange-600 transition-colors">FAQ</Link></li>
                            <li><Link href="/policy" className="hover:text-orange-600 transition-colors">Privacy Policy</Link></li>
                            <li><Link href="/terms" className="hover:text-orange-600 transition-colors">Terms of Service</Link></li>
                        </ul>
                    </div>

                    {/* Newsletter Card */}
                    <div className="md:col-span-3">
                        <div className="bg-neutral-50 border border-neutral-100 rounded-2xl p-6">
                            <p className="text-neutral-900 font-bold mb-1">
                                Start with 5 free leads.
                            </p>
                            <p className="text-sm text-neutral-500 mb-4 font-medium">
                                Try The Scout agent today.
                            </p>
                            <Link href="/login?mode=signup">
                                <button className="w-full bg-neutral-900 hover:bg-neutral-800 text-white font-medium py-3 rounded-xl transition-colors shadow-sm cursor-pointer">
                                    Create Free Account
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="pt-8 border-t border-neutral-100 flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex items-center gap-6">
                        <p className="text-sm text-neutral-400 font-medium">© 2026 Axist Inc.</p>
                        <div className="flex gap-4">
                            <a href="https://twitter.com/999tommy__" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-neutral-900 transition-colors" aria-label="Twitter">
                                <Twitter size={18} />
                            </a>
                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-neutral-900 transition-colors" aria-label="LinkedIn">
                                <Linkedin size={18} />
                            </a>
                        </div>
                    </div>

                    <div className="flex items-center gap-2">
                        <span className="flex h-2 w-2 rounded-full bg-emerald-500"></span>
                        <span className="text-sm text-neutral-500 font-medium">All systems operational</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};
